"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PathObjectData = require("./pathObjectData.js");
var PathType = require("./pathType.js");
var SVGToMesh = require("./../threejsExport/svgToMesh.js");

var PathData = function (startPoint, strokeWidth, color, fill, closed) {
    var self = this;

    this.makeObservableTreeNode();

    this.objects = this.list("objects", true);
    this.closed = this.value("closed", true);
    this.fill = this.value("fill", true);
    this.strokeWidth = this.value("strokeWidth", true);
    this.color = this.value("color", true);     // if color == null, color is inherited from parent layer

    this.smallestDimension = 1e-6;

    this.origObjectRatios = {
        TOP: {},
        SUBELEMENTS: {}
    };

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [[this.objects, this.objects.onBubble],
         this.fill, this.closed]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.geometry]
    );


    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.geometry().getBB(); },
        [this.geometry]
    );

    SVGToMesh.call(this);

    this.pos = this.shadow('pos',
        function () {
            return self.getPos();
        },
        function (val) {
            return self.setPos(val);
        },
        [[this, this.onBubble]]);

    this.angle = this.shadow('angle',
        function () {
            return 0;
        },
        function (val) {
            return self.rotate(val, self.getPos());
        },
        []);

    this.width = this.shadow('width',
        function () {
            return self.getWidth();
        },
        function (val) {
            return self.setWidth(val);
        },
        [[self, self.onBubble]]);

    this.height = this.shadow('height',
        function () {
            return self.getHeight();
        },
        function (val) {
            return self.setHeight(val);
        },
        [[self, self.onBubble]]);

    // First object is a point
    if (startPoint !== undefined) this.addObject(new PathObjectData(startPoint, PathType.POINT, new lib_geometry.Coord(0, 0), new lib_geometry.Coord(0, 0)));
    if (strokeWidth !== undefined) this.strokeWidth(strokeWidth);
    if (color !== undefined) this.color(color);
    if (fill !== undefined) this.fill(fill);
    else this.fill(false);
    if (closed !== undefined) this.closed(closed);
    else this.closed(false);
};
lib_core.mixin(PathData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PathData, "PathData");

module.exports = PathData;

PathData.prototype.putObject = function (j, object) {
    this.objects.put(j, object);
};

PathData.prototype.addObject = function (object, j) {

    if (j === undefined) {
        this.objects.push(object);
    } else {
        this.objects.add(j, object);
    }
};

// Returns the endpoint of the last object in this path
PathData.prototype.getEndpoint = function () {
    return (this.objects.last().endpoint());
};

PathData.prototype.calcCenter = function () {
    var xMinMax = this.getXMinMax();
    var yMinMax = this.getYMinMax();
    return new lib_geometry.Coord((xMinMax.min + xMinMax.max) / 2, (yMinMax.min + yMinMax.max) / 2);
};

PathData.prototype.getPos = function () {
    return this.calcCenter();
};

PathData.prototype.setPos = function (newPos) {
    var diffVec = newPos.sub(this.getPos());
    this.move(diffVec);
};

PathData.prototype.rotate = function (angle, center) {
    if (!center) {
        center = this.calcCenter();
    }
    this.objects.forEach(function (index, object) {
        object.rotate(angle, center);
    });
};

PathData.prototype.flip = function (flipline) {
    if (!flipline) {
        flipline = this.calcCenter().y;
    }
    this.objects.forEach(function (index, object) {
        object.flip(flipline);
    });
};

PathData.prototype.move = function (vec) {
    this.objects.forEach(function (index, object) {
        object.move(vec);
    });
    this.boundingBox();
};

PathData.prototype._getGeometry = function () {
    var path = new lib_geometry.Path(path);

    if (this.closed()) {
        path.moveTo(this.objects.get(-1).endpoint().getX(), this.objects.get(-1).endpoint().getY());
    }

    this.objects.forEach(function (index, object) {
        if (object.type() == PathType.POINT) {
            path.moveTo(object.endpoint().getX(), object.endpoint().getY());
        } else if (object.type() == PathType.LINE) {
            path.lineTo(object.endpoint().getX(), object.endpoint().getY());
        } else if (object.type() == PathType.CURVEC) {
            path.curveTo(object.tan_0().getX(), object.tan_0().getY(),
                object.tan_1().getX(), object.tan_1().getY(),
                object.endpoint().getX(), object.endpoint().getY());
        } else if (object.type() == PathType.ARC) {
            path.arcTo(object.xRadius(), object.yRadius(),
                object.angle(),
                (object.largeArcFlag() ? 1 : 0), (object.sweepFlag() ? 1 : 0),
                object.endpoint().getX(), object.endpoint().getY());
        } else {
            console.error("Unsupported path object type");
        }
    });

    if (this.closed()) {
        path.close();
    }

    if (this.fill()) {
        path.fill(true);
    }

    return path;
};

//Incomplete implementation used for debugging
PathData.prototype.fromGeometryPath = function (path) {
    var self = this;
    var o;
    path = path.toAbsolutePath();
    path.path.forEach(function (pathElement) {
        if (pathElement[0] == 'M') {
            self.addObject(new PathObjectData(new lib_geometry.Coord(pathElement[1], pathElement[2]), PathType.POINT));
        } else if (pathElement[0] == 'L') {
            self.addObject(new PathObjectData(new lib_geometry.Coord(pathElement[1], pathElement[2]), PathType.LINE));
        } else if (pathElement[0] == 'A') {
            o = new PathObjectData(new lib_geometry.Coord(pathElement[6], pathElement[7]), PathType.ARC);
            o.xRadius(pathElement[1]);
            o.yRadius(pathElement[2]);
            o.angle(pathElement[3]);
            o.largeArcFlag(pathElement[4]);
            o.sweepFlag(pathElement[5]);
            self.addObject(o);
        } else if (pathElement[0] == 'Z') {
            self.closed(true);
        } else {
            //missing support for bezier and arc
            console.error("Unsupported path object type: "+pathElement[0]);
        }
    });
};

PathData.prototype._getSegmentedGeometry = function(precision) {
    return this.geometry().toSegmented(precision);
};
 

PathData.prototype.getYMinMax = function () {
    var polyBB = this.boundingBox();
    return {min: polyBB.getYMin(), max: polyBB.getYMax()};
};

PathData.prototype.getXMinMax = function () {
    var polyBB = this.boundingBox();
    return {min: polyBB.getXMin(), max: polyBB.getXMax()};
};

PathData.prototype.getHeight = function () {
    var yMinMax = this.getYMinMax();
    return yMinMax.max - yMinMax.min;
};

PathData.prototype.getWidth = function () {
    var xMinMax = this.getXMinMax();
    return xMinMax.max - xMinMax.min;
};

PathData.prototype.setHeight = function (newHeight) {
    var curHeight = this.height();
    if (this.objects.size() > 1 && curHeight > 0) {
        // update relative to center position
        var curPos = this.getPos();
        this.objects.forEach(function (index, object) {
            /**
             * new x position should be same ratio in relation to center point but using new width
             */
            var ep = object.endpoint();
            var tan_0 = object.tan_0();
            var tan_1 = object.tan_1();

            // endpoint
            var oldDiff = ep.getY() - curPos.getY();
            var oldRatio = oldDiff / curHeight;
            var newY = newHeight * oldRatio + curPos.getY();
            object.endpoint(new lib_geometry.Coord(ep.getX(), newY));

            if(object.type() == PathType.CURVEC) {
                // tan_0
                oldDiff = tan_0.getY() - curPos.getY();
                oldRatio = oldDiff / curHeight;
                newY = newHeight * oldRatio + curPos.getY();
                object.tan_0(new lib_geometry.Coord(tan_0.getX(), newY));

                // tan_1
                oldDiff = tan_1.getY() - curPos.getY();
                oldRatio = oldDiff / curHeight;
                newY = newHeight * oldRatio + curPos.getY();
                object.tan_1(new lib_geometry.Coord(tan_1.getX(), newY));

            } else if(object.type() == PathType.ARC) {
                var ellipse = new lib_geometry.Ellipse(
                    object.largeRadius(),
                    object.smallRadius(),
                    object.largeArcAxisAngle());
                ellipse.scale(1.0, newHeight/curHeight);

                // very careful here, the value of a always goes wih xRadius because the
                // angle is referenced from there and with a
                object.xRadius(ellipse.a);
                object.yRadius(ellipse.b);
                object.angle(ellipse.angle);
            }

        });
    }
};

PathData.prototype.setWidth = function (newWidth) {
    var curWidth = this.getWidth();
    if (this.objects.size() > 1 && curWidth > 0) {
        // update relative to center position
        var curPos = this.getPos();
        this.objects.forEach(function (index, object) {
            /**
             * new x position should be same ratio in relation to center point but using new width
             */
            var ep = object.endpoint();
            var tan_0 = object.tan_0();
            var tan_1 = object.tan_1();

            // endpoint
            var oldDiff = ep.getX() - curPos.getX();
            var oldRatio = oldDiff / curWidth;
            var newX = newWidth * oldRatio + curPos.getX();
            object.endpoint(new lib_geometry.Coord(newX, ep.getY()));

            if(object.type() == PathType.CURVEC) {
                // tan_0
                oldDiff = tan_0.getX() - curPos.getX();
                oldRatio = oldDiff / curWidth;
                newX = newWidth * oldRatio + curPos.getX();
                object.tan_0(new lib_geometry.Coord(newX, tan_0.getY()));

                // tan_1
                oldDiff = tan_1.getX() - curPos.getX();
                oldRatio = oldDiff / curWidth;
                newX = newWidth * oldRatio + curPos.getX();
                object.tan_1(new lib_geometry.Coord(newX, tan_1.getY()));

            } else if(object.type() == PathType.ARC) {
                var ellipse = new lib_geometry.Ellipse(
                    object.largeRadius(),
                    object.smallRadius(),
                    object.largeArcAxisAngle());
                ellipse.scale(newWidth/curWidth, 1.0);

                // very careful here, the value of a always goes wih xRadius because the
                // angle is referenced from there and with a
                object.xRadius(ellipse.a);
                object.yRadius(ellipse.b);
                object.angle(ellipse.angle);
            }
        });
    }
};

//Debug code
PathData.prototype.expand = function(deterministic, precision) {
    var geometryPath = this.geometry();
    // var geometryPath = this.boundingBox();
    var destination = this.parentCollection[0]; // if no destination is given, expand in own parent
    // this.remove();   // if expanding in own parent, first remove original generator

    var buf = geometryPath.toPolygon(precision);//.buffer(50);
    geometryPath = buf.toPath();

    var path = new PathData();
    path.strokeWidth(this.strokeWidth());
    path.fromGeometryPath(geometryPath);
    path.addTo(destination);
};
